// extracted by mini-css-extract-plugin
export default {"container":"NavPanel_container__UZ35-","settings":"NavPanel_settings__nYJ+I"};